import { Fragment, useState } from "react";
import { Button, Card, CardBody, Col, Tooltip } from "reactstrap";
import { TooltipDirectionTitle, TooltipOn } from "../../../constants";
import { TooltipDirectionSubTitle, TooltipPosition } from "../../../data/uiKits/Tooltip";
import { Placement } from "../../../types/UiKits";
import CommonCardHeader from "../../../coreComponents/CommonCardHeader";

const TooltipDirection = () => {
  const [openIndex, setOpenIndex] = useState(-1);
  const toggleTooltip = (index: number) => setOpenIndex(openIndex === index ? -1 : index);

  return (
    <Col md="6">
      <Card>
        <CommonCardHeader title={TooltipDirectionTitle} span={TooltipDirectionSubTitle} />
        <CardBody>
          <div className="common-flex">
            {TooltipPosition &&
              TooltipPosition.map((item, index) => (
                <Fragment key={index}>
                  <Button color={item.class} id={`direction_${index}`} onClick={() => toggleTooltip(index)}>
                    {TooltipOn} {item.position}
                  </Button>
                  <Tooltip isOpen={openIndex === index} placement={item.position as Placement} target={`direction_${index}`} toggle={() => toggleTooltip(index)}>
                    {TooltipOn} {item.position}
                  </Tooltip>
                </Fragment>
              ))}
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};
export default TooltipDirection;
